import { Fragment } from 'react';
import { observer } from 'mobx-react';
import { useToggle } from '@cutwise/react-utils';

import Alert, { ALERT_WARNING } from '@/common/components/Alert/Alert';
import Modal from '@/common/components/Modal/Modal';
import { NetboxStatus } from '@/netbox/constants/statuses';
import { useNetBoxStore } from '@/netbox/stores/NetBoxStore';

import LoadingTaskList from '../LoadingTaskList/LoadingTaskList';

import logo from './logo.svg';
import styles from './NetBoxIndicator.module.css';

function NetBoxIndicator() {
  const { isAccessible, isServiceWorkerActivated, status } = useNetBoxStore();

  const [isModalOpened, , , toggleModalOpened] = useToggle();

  function toggleModal() {
    if (!status) {
      return;
    }

    toggleModalOpened();
  }

  if (!isAccessible) {
    return null;
  }

  return (
    <Fragment>
      <Modal
        title="NetBox Control Panel"
        onClose={toggleModal}
        isShowed={status !== NetboxStatus.Disabled && isModalOpened}
      >
        <div className={styles.alert}>
          {!isServiceWorkerActivated && (
            <Alert type={ALERT_WARNING}>
              To serve content from the cache and intercept network requests Service Worker must be enabled. Check your
              browser settings
            </Alert>
          )}
        </div>

        <LoadingTaskList />
      </Modal>

      <img src={logo} height={32} width={32} alt="NetBox" aria-label="Open NetBox control panel" className={styles.indicator} onClick={toggleModal} />
    </Fragment>
  );
}

export default observer(NetBoxIndicator);
